import React from 'react';
import { Icon } from 'semantic-ui-react';

const SearchFieldIcon = ({ searchValue, setSearchValue, handleSearch }) => {
  return searchValue ? (
    <Icon
      name="times circle"
      link
      onClick={() => {
        setSearchValue('');
        handleSearch('');
      }}
    />
  ) : (
    <Icon name="search" />
  );
};

export default SearchFieldIcon;
